var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-bar"},[(_vm.$store.state.publication.enableMarketsTicker)?_c('MarketsTicker',{on:{"mount":_vm.notifyTopBarUpdate}}):_vm._e(),_vm._v(" "),_c('Navbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }